import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { ellipsisText, flexCenterAligned } from '@/styles/common';

export const Chip = styled.div`
  ${flexCenterAligned}
  width: fit-content;
  flex: 0 0 auto;
  height: 34px;
  padding: 10px 15px;
  border-radius: 50px;
  background-color: var(--bg-card);
  border: 1px solid var(--card-chip-border);

  @media (max-width: ${BREAKPOINTS.mobile}) {
    height: 30px;
  }
`;

export const Label = styled(Typography)<{ $isClipped: boolean }>`
  ${({ $isClipped }) =>
    $isClipped &&
    css`
      ${ellipsisText}
      white-space: nowrap;
    `}
`;
